import { RootState } from '@AppState/redux-store'
import { useSelector } from 'react-redux'
import { hostConfigByName } from '../config/utils'

export function useHostConfig() {
  const hostName = useSelector((state: RootState) => state.appConfig.config?.hostName)

  if (!hostName) {
    throw new Error('Unable to determine host name')
  }

  const hostConfig = hostConfigByName[hostName]

  if (!hostConfig) {
    throw new Error(`No host config found for host name "${hostName}"`)
  }

  return hostConfig
}
